export default "__VITE_ASSET__CKoXxXmC__"